import { render } from "./AiTrims.vue?vue&type=template&id=de1fb6d8&scoped=true"
import script from "./AiTrims.vue?vue&type=script&lang=js"
export * from "./AiTrims.vue?vue&type=script&lang=js"

import "./AiTrims.vue?vue&type=style&index=0&id=de1fb6d8&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1fb6d8"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiTrims.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de1fb6d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de1fb6d8', __exports__)) {
    api.reload('de1fb6d8', __exports__)
  }
  
  module.hot.accept("./AiTrims.vue?vue&type=template&id=de1fb6d8&scoped=true", () => {
    api.rerender('de1fb6d8', render)
  })

}


export default __exports__